import { render, staticRenderFns } from "./receipt-detail.vue?vue&type=template&id=21cff8be&scoped=true&"
import script from "./receipt-detail.vue?vue&type=script&lang=js&"
export * from "./receipt-detail.vue?vue&type=script&lang=js&"
import style0 from "./receipt-detail.vue?vue&type=style&index=0&id=21cff8be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cff8be",
  null
  
)

export default component.exports